var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"color":"grey lighten-2blue-grey lighten-4","elevation":"1","height":"100"}},[_c('div',{staticClass:"btnCloseAnexo"},[_c('v-icon',{attrs:{"color":"red"},on:{"click":function($event){return _vm.$emit('remove', _vm.posicao)}}},[_vm._v(" mdi-close-circle ")])],1),_c('v-img',{attrs:{"src":_vm.arquivo.localUrl}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }